import { type CustomerReviewType } from '@/legacy-src/components/reviews/types'

import { type TherapistType } from '../types/TherapistStateType'
import { rewriteTherapistCredentials } from './selectorHelpers'

// ===================================
// ========= REST API Utils ==========
// ===================================

export const API_URL = `${process.env.NEXT_PUBLIC_API_URL}${process.env.NEXT_PUBLIC_API_VERSION}`

export const getApiUrlForDomain = (tld: string) =>
  tld === 'test' ? 'https://test-api.hedepy.cz/api/v2' : `https://api.hedepy.${tld}/api/v2`

export const getApiHearmeLink = (tld: string, sharedCode: string, policyCode: string) =>
  `${getApiUrlForDomain(tld)}/company/public/hearme/link?sharedCode=${encodeURIComponent(sharedCode)}&policyCode=${encodeURIComponent(policyCode)}`

export const fetchFromApi = async <T = any>(route: string, options: RequestInit = {}): Promise<T> => {
  const res = await fetch(`${API_URL}/${route}`, {
    next: {
      // helps ease the load on the API during builds
      revalidate: 5 * 60,
    },
    ...options,
  })
  return res.json()
}

export const processTherapistList = (therapists: TherapistType[]) => {
  return therapists.map((therapist) => rewriteTherapistCredentials(therapist))
}

export const fetchProcessedTherapists = async () => {
  const therapists = await fetchFromApi('therapist/list-open')
  return processTherapistList(therapists)
}

export const fetchUseVisiblePremiumContent = async () => {
  const visibleContent = await fetchFromApi('premium-content/teasers')
  return visibleContent
}

export const fetchUseServices = async () => fetchFromApi('service?scope=therapist')

export const fetchUseSpecializations = async () => {
  const res = await fetchFromApi('therapist/specializations')
  return res
}

export type ReviewFetchType = 'all' | 'employees'
export const fetchReviews = async (page: number, type: ReviewFetchType = 'all'): Promise<CustomerReviewType[]> => {
  const res = await fetchFromApi(`review/list?page=${page}&type=${type}`)
  return res
}
